export type Theme = 'light' | 'dark';

export const color = {
  brightBlue: '#3498db',
  darkGrayishBlue: '#8b8d94',
  darkRed: '#a90000',
  grayishBlue: '#A4A6B3',
  grayishBlue2: '#9fa2b4',
  grayishBlue3: '#bdc3c7',
  lightBlue: '#3751FF',
  lightGrayishBlue: '#F7F8FC', 
  lightGrayishBlue2: '#DFE0EB',
  paleBlue: '#DDE2FF',
  paleBlueTransparent: 'rgba(221, 226, 255, 0.08)',
  veryDarkGrayishBlue: '#373a47',
  white: "#FFF",
  gray: "#202e56",
  slate: "#cbd5e1",
  sidebarActive : "#ffffff1f"
};

export const themes = {
  light: {
    sidebar: {
      backgroundColor: '#202e56',
      color: color.slate,
    },
    headerFooterColor: {
      backgroundColor: '#417eb8d5',
      color: '#00203f32',
    },
    menu: {
      menuContent: '#fbfcfd',
      icon: '#0098e5',
      hover: {
        backgroundColor: color.sidebarActive,
        color: color.white,
      },
      // active: {      
      //   backgroundColor: "#e5e7eb",
      // },
      disabled: {
        color: '#9fb6cf',
      },
    },
  },
  dark: {
    sidebar: {
      backgroundColor: "#202e56",
      color: color.slate,
    },
    headerFooterColor: {
      backgroundColor: '#00203f32',
      color: '#8ba1b7',
    },
    menu: {
      menuContent: color.gray,  //nested menu bg color
      icon: color.slate,
      hover: {
        backgroundColor: color.sidebarActive,
        color: color.white,
      },
      disabled: {
        color: '#3e5e7e',
      },
    },
  },
};


export const typography = {
  cardTitle: {
      fontWeight: 'bold',
      fontSize: 19,
      lineHeight: '24px',
      letterSpacing: '0.4px'
  },
  smallSubtitle: {
      fontSize: 12,
      lineHeight: '16px',
      letterSpacing: '0.1px'
  },
  link: {
      fontWeight: '600',
      fontSize: 14,
      lineHeight: '20px',
      letterSpacing: '0.2px',
      color: color.lightBlue,
      textAlign: 'right',
      cursor: 'pointer',
      textDecoration: 'underline',
      '&:hover': {
          color: color.grayishBlue
      }
  },
  itemTitle: {
      fontWeight: 600,
      fontSize: 14,
      lineHeight: '20px',
      letterSpacing: 0.2
  },
  title: {
      fontWeight: 'bold',
      fontSize: 24,
      lineHeight: '30px',
      letterSpacing: 0.3
  }
};
